import React, { Component } from "react";
import {
  PageHeader,
  Spin,
  Row,
  Col,
  Select,
  message,
  Tag,
} from "antd";
import {
  dineroDisabledMask,
  Form,
  FormItem,
  InputNumberItem,
  SelectItem,
  DatePickerItem,
  ButtonItem,
  InputItem,
  SelectFacturasItem,
} from "../../../../Components/Items";
import axios from "axios";
import moment from "moment";
import "moment/locale/es";
import { connect } from "react-redux";
import { DollarOutlined, InfoCircleOutlined, CarOutlined, EnvironmentOutlined, PhoneFilled, UserOutlined } from "@ant-design/icons";
import GeneralFormLayout from "../../../../Components/GeneralFormLayout";
import InfoCard from "../../../../Components/InfoCard";
import PagosNotaDeCredito from "../PagosNotaDeCredito/PagosNotaDeCredito";

const { Option } = Select;

moment.locale("es");

class VerNotaDeCredito extends Component {
  formRef = React.createRef();
  state = {
    loading: false,
    objetoProveedores: null,
    todasProveedores: null,
    objetoProyectos: null,
    todasProyectos: null,
    objetoInsumos: (
      <Option disabled value={0} key={0}>
        Seleccione un proveedor primero
      </Option>
    ),
    todasInsumos: [],
    todasMonedas: null,
    objetoMonedas: null,
    impuestos: [],
    total: 0,
    totalPagar: 0,
    totalPagado: 0,
    subtotal: 0,
    ajusteSubtotal: 0,
    arrayImpuestos: [],
    arrayRetenciones: [],
    modalPagos: false,
    estado: 0,
    id: this.props.location.state.id,
  };
  componentDidMount() {
    this.consultarTodo();
  }
  guardarDescripcion() {
    axios
      .post(
        "notasDeCreditoCompra/editarDescripcion",
        {
          notaDeCreditoId: this.state.id,
          empresaId: this.props.empresaId,
          descripcion: this.formRef.current?.getFieldValue("descripcion"),
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success !== 2) {
          message.warning("Error al guardar la descripcion");
        } else {
          message.success("Descripcion actualizada");
        }
      })
      .catch(() => {
        message.error("Error al guardar la descripcion");
      });
  }
  async consultarTodo() {
    this.setState({ loading: true });
    await axios
      .post(
        "notasDeCreditoCompra/datosNota",
        { empresaId: this.props.empresaId, notaId: this.state.id },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          let newState = {
            estado: res.data.notaDeCredito.estado,
            total: res.data.notaDeCredito.total,
            totalPagar: res.data.notaDeCredito.totalPagar,
            totalPagado: res.data.notaDeCredito.totalPagado,
            subtotal: res.data.notaDeCredito.subtotal,
            arrayImpuestos: res.data.notaDeCredito.arrayImpuestos,
            arrayRetenciones: res.data.notaDeCredito.arrayRetenciones,
            ajusteSubtotal: res.data.notaDeCredito.ajusteSubtotal,
            todasMonedas: res.data.monedas,
            objetoMonedas: res.data.monedas.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombre + " - " + value.abreviacion}
                </Option>
              );
            }),
            todasProyectos: res.data.proyectos,
            objetoProyectos: res.data.proyectos.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombre}
                </Option>
              );
            }),
            todasProveedores: res.data.proveedores,
            objetoProveedores: res.data.proveedores.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.stringBuscar}
                </Option>
              );
            }),
            todasInsumos: res.data.insumos,
            objetoInsumos: res.data.insumos.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombre || value.descripcion}
                </Option>
              );
            }),
          }

          this.setState(newState, () => {
            this.formRef.current.setFieldsValue({
              ...res.data.notaDeCredito,
              fechaFactura: moment(res.data.notaDeCredito.fechaFactura),
              insumos: res.data.notaDeCredito.insumos.map(insumo => {
                const precioUnitarioConImpuestos = insumo.precioUnitario + (insumo.impuestos / insumo.cantidad)
                return { ...insumo, precioUnitarioConImpuestos }
              })
            });
          })
        } else {
          message.error("Error no se encontro informacion de la nota de credito");
        }
      });

    this.setState({ loading: false });
  }
  atras() {
    this.props.history.goBack();
  }
  cerrarPagosNotaDeCredito() {
    this.consultarTodo()
    this.setState({
      modalPagos: false,
    });
  }

  renderProyectoCard() {
    return (
      <FormItem shouldUpdate noStyle>
        {({ getFieldValue }) => {
          const proyectoId = getFieldValue("proyectoId");
          const proveedorId = getFieldValue("proveedorId");
          const proyecto = proyectoId
            ? this.state.todasProyectos?.find((v) => v._id === proyectoId)
            : null;
          const proveedor = proveedorId
            ? this.state.todasProveedores?.find((v) => v._id === proveedorId)
            : null;

          if (!proyecto && !proveedor) return null;

          const proveedorSections = proveedor
            ? [
                {
                  title: "Datos generales",
                  icon: <InfoCircleOutlined />,
                  iconColor: "#00BFD6",
                  lg: 14,
                  items: [
                    {
                      label: "Nombre",
                      value: proveedor.nombre
                        ? `${proveedor.nombre} ${proveedor.apellidoPaterno} ${proveedor.apellidoMaterno}`
                        : proveedor.razonSocial || "-",
                      bold: true,
                    },
                    { label: "RFC",      value: proveedor.rfc      || "-" },
                    { label: "Correo",   value: proveedor.correo   || "-" },
                    { label: "Teléfono", value: proveedor.telefono || "-" },
                    { label: "Celular",  value: proveedor.celular  || "-" },
                  ],
                },
                {
                  title: "Contacto",
                  icon: <PhoneFilled />,
                  iconColor: "#DB2777",
                  lg: 10,
                  items: [
                    { label: "Nombre",          value: proveedor.nombreContacto   || "-" },
                    { label: "Teléfono",        value: proveedor.telefonoContacto || "-" },
                    { label: "Correo",          value: proveedor.correoContacto   || "-" },
                    { label: "Días de crédito", value: proveedor.diasCredito       ?? "-" },
                  ],
                },
              ]
            : [];

          if (!proyecto) {
            return (
              <Row>
                <InfoCard title="PROVEEDOR" accentColor="#00BFD6" compact sections={proveedorSections} />
              </Row>
            );
          }

          return (
            <Row>
              <InfoCard
                title="PROYECTO"
                accentColor="#00BFD6"
                icon={<InfoCircleOutlined />}
                compact
                sections={[
                  {
                    title: "Información General",
                    icon: <InfoCircleOutlined />,
                    iconColor: "#00BFD6",
                    lg: 8,
                    items: [
                      { label: "Nombre",      value: proyecto.nombre      || "-" },
                      { label: "Descripción", value: proyecto.descripcion || "-" },
                    ],
                  },
                  {
                    title: proyecto.calle ? "Dirección" : "Vehículo",
                    icon: proyecto.calle ? <EnvironmentOutlined /> : <CarOutlined />,
                    iconColor: "#C9DF00",
                    lg: 8,
                    items: proyecto.calle
                      ? [{ label: "Calle", value: `${proyecto.calle} #${proyecto.numeroCalle || "-"}` }]
                      : [
                          { label: "Marca",  value: proyecto.marca  || "-" },
                          { label: "Modelo", value: proyecto.modelo || "-" },
                          { label: "Placas", value: proyecto.placas || "-" },
                        ],
                  },
                  {
                    title: "Detalles",
                    icon: <CarOutlined />,
                    iconColor: "#FF6A0D",
                    lg: 8,
                    items: [
                      { label: "Tipo", value: proyecto.calle ? "Dirección física" : "Vehículo" },
                      { label: "ID",   value: proyecto._id ? proyecto._id.slice(-6).toUpperCase() : "-" },
                    ],
                  },
                ]}
                splitWith={
                  proveedor
                    ? {
                        title: "PROVEEDOR",
                        accentColor: "#00BFD6",
                        icon: <UserOutlined />,
                        compact: true,
                        sections: proveedorSections,
                      }
                    : undefined
                }
              />
            </Row>
          );
        }}
      </FormItem>
    );
  }

  getInsumosColumns() {
    return [
      { title: "Clave",  width: "5%" },
      { title: "Insumo", width: "25%" },
      { title: "Unidad", width: "5%" },
      { title: "P.U.",   width: "12%" },
      { title: "P.U. c/Imp.",  width: "12%" },
      { title: "Cant.", width: "12%" },
      { title: "Subtotal/Imp./Total", width: "12%" },
    ];
  }

  getFacturasColumns() {
    return [
      { title: "UUID Relacionado", width: "55%" },
      { title: "T. C. Compra",     width: "20%" },
      { title: "Monto a aplicar",  width: "25%" },
    ];
  }

  renderInsumoRow({ key, name, fieldKey, restField, arrayKey }) {
    return (
      <React.Fragment key={key}>
        <tr>
          <td className="td-border">
            <FormItem noStyle shouldUpdate>
              {({ getFieldValue }) => {
                const insumoId = getFieldValue(['insumos', arrayKey, 'insumoId']);
                const insumoSeleccionado = this.state.todasInsumos?.find(
                  (insumo) => insumo._id.toString() === insumoId?.toString()
                );
                return (
                  <div style={{ fontSize: '14px', textAlign: 'center', color: '#868585' }}>
                    {insumoSeleccionado?.clave || '-'}
                  </div>
                );
              }}
            </FormItem>
          </td>
          <td className="td-border">
            <FormItem {...restField} name={[name, "insumoId"]} fieldKey={[arrayKey, "insumoId"]} required noStyle>
              <SelectItem sinBorde autoFocus style={{ width: "100%" }} placeholder="Insumo" disabled >
                {this.state.objetoInsumos}
              </SelectItem>
            </FormItem>
          </td>
          <td className="td-border">
              <FormItem noStyle shouldUpdate>
                {({ getFieldValue }) => {
                  const insumoId = getFieldValue(['insumos', arrayKey, 'insumoId']);
                  const insumoSeleccionado = this.state.todasInsumos?.find(
                    (insumo) => insumo._id.toString() === insumoId?.toString()
                  );
                  return (
                    <div style={{ fontSize: '14px', textAlign: 'center' , color: '#868585'}}>
                      {insumoSeleccionado?.unidad || '-'}
                    </div>
                  );
                }}
              </FormItem>
          </td>
          <td className="td-border">
            <FormItem {...restField} name={[name, "precioUnitario"]} fieldKey={[arrayKey, "precioUnitario"]} noStyle required>
              <InputNumberItem sinBorde placeholder="P.U." disabled dinero />
            </FormItem>
          </td>
          <td className="td-border">
            <FormItem name={[name, "precioUnitarioConImpuestos"]} noStyle required shouldUpdate>
              <InputNumberItem sinBorde disabled placeholder="P.U. c/Imp." dineroDisabled />
            </FormItem>
          </td>
          <td className="td-border">
            <FormItem {...restField} name={[name, "cantidad"]} fieldKey={[arrayKey, "cantidad"]} required number noStyle>
              <InputNumberItem sinBorde placeholder="Cant." disabled />
            </FormItem>
          </td>
          <td className="td-border">
            <FormItem noStyle shouldUpdate>
              {({ getFieldValue }) => {
                const subtotal  = getFieldValue(["insumos", arrayKey, "subtotal"])  || 0;
                const impuestos = getFieldValue(["insumos", arrayKey, "impuestos"]) || 0;
                const total     = getFieldValue(["insumos", arrayKey, "total"])     || 0;
                return (
                  <div className="celda-totales" style={{ fontSize: "12px" }}>
                    <div>{dineroDisabledMask(subtotal)}</div>
                    <div>{dineroDisabledMask(impuestos)}</div>
                    <div className="total-bold">Total: {dineroDisabledMask(total)}</div>
                  </div>
                );
              }}
            </FormItem>
            <FormItem {...restField} name={[name, "subtotal"]}  fieldKey={[arrayKey, "subtotal"]}  hidden><InputNumberItem /></FormItem>
            <FormItem {...restField} name={[name, "impuestos"]} fieldKey={[arrayKey, "impuestos"]} hidden><InputNumberItem /></FormItem>
            <FormItem {...restField} name={[name, "total"]}     fieldKey={[arrayKey, "total"]}     hidden><InputNumberItem /></FormItem>
          </td>
        </tr>
      </React.Fragment>
    );
  }

  renderFacturaRow({ key, name, fieldKey, restField, arrayKey }) {
    return (
      <React.Fragment key={key}>
        <tr>
          <td className="td-border">
            <FormItem {...restField} name={[name, "facturaId"]} fieldKey={[arrayKey, "facturaId"]} required noStyle>
              <SelectFacturasItem
                empresaId={this.props.empresaId}
                headersToken={this.props.headersToken}
                sinBorde autoFocus dropdownMatchSelectWidth={600} width="100%" placeholder="Factura" disabled
                proveedorId={this.formRef.current ? this.formRef.current.getFieldValue("proveedorId") : null}
              />
            </FormItem>
          </td>
          <td className="td-border">
            <FormItem {...restField} name={[name, "tipoDeCambioCompra"]} fieldKey={[arrayKey, "tipoDeCambioCompra"]} noStyle number initialValue={1}>
              <InputNumberItem sinBorde disabled dinero />
            </FormItem>
          </td>
          <td className="td-border">
            <FormItem {...restField} name={[name, "montoPago"]} fieldKey={[arrayKey, "montoPago"]} noStyle number>
              <InputItem sinBorde disabled />
            </FormItem>
          </td>
        </tr>
      </React.Fragment>
    );
  }

  getObservacionesConfig() {
    return {
      totales: (
        <div style={{ marginTop: 8 }}>
          <table className="table" style={{ borderCollapse: "collapse", width: "100%", margin: 0 }}>
            <tbody>
              <tr>
                <th className="td-totales-center" style={{ width: "50%" }}></th>
                <td className="td-totales-center" style={{ width: "30%" }}>
                  <Tag style={{ backgroundColor: "#f5f5f5", borderColor: "#d9d9d9", color: "#595959", fontWeight: 600, padding: "2px 30px", borderRadius: "6px" }}>
                    Ajuste
                  </Tag>
                </td>
                <td className="td-totales-center" style={{ width: "30%" }}></td>
              </tr>
              <tr>
                <th className="th-totales" style={{ width: "50%" }}>Subtotal</th>
                <td className="td-totales-right" style={{ width: "20%" }}>
                  <InputNumberItem sinBorde dineroDisabled disabled value={this.state.ajusteSubtotal} />
                </td>
                <td className="td-totales-right" style={{ width: "50%" }}>
                  {dineroDisabledMask(this.state.subtotal)}
                </td>
              </tr>
            </tbody>
            {this.state.arrayImpuestos.map((valueArray) => (
              <tbody key={valueArray.descripcionFactura}>
                <tr>
                  <th className="th-totales">{valueArray.descripcionFactura}</th>
                  <td className="td-totales-right" style={{ width: "20%" }}>
                    <InputNumberItem sinBorde dineroDisabled disabled value={valueArray.ajusteImpuesto} />
                  </td>
                  <td className="td-totales-right">{dineroDisabledMask(valueArray.totalImpuestos)}</td>
                </tr>
              </tbody>
            ))}
            <tbody>
              <tr>
                <th className="th-totales">Total</th>
                <td className="td-totales-right" style={{ width: "20%" }}></td>
                <td className="td-totales-right">{dineroDisabledMask(this.state.total)}</td>
              </tr>
            </tbody>
            {this.state.arrayRetenciones.map((value) => (
              <tbody key={value.descripcionFactura}>
                <tr>
                  <th className="th-totales">{value.descripcionFactura}</th>
                  <td className="td-totales-right" style={{ width: "20%" }}>
                    <InputNumberItem sinBorde dineroDisabled disabled value={value.ajusteRetencion} />
                  </td>
                  <td className="td-totales-right">{dineroDisabledMask(value.totalRetenciones)}</td>
                </tr>
              </tbody>
            ))}
            <tbody>
              <tr>
                <th className="th-totales">Total a pagar</th>
                <td className="td-totales-right" style={{ width: "20%" }}></td>
                <td className="td-totales-right">{dineroDisabledMask(this.state.totalPagar)}</td>
              </tr>
            </tbody>
          </table>
        </div>
      ),
    };
  }

  render() {
    const isMobile = window.innerWidth < 768;
    return (
      <>
        <PageHeader
          onBack={this.atras.bind(this)}
          title="Nota de Credito"
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
        />
        <div className="card-background">
          <Spin spinning={this.state.loading}>
            <Form ref={this.formRef} name="verNotaDeCredito" layout>
              <div style={{ padding: "0 16px", marginBottom: 16 }}>
                {this.renderProyectoCard()}
              </div>
              <GeneralFormLayout
                cards={[
                   {
                    title: "Datos Factura",
                    lg: 18,
                    content: (
                      <Row>
                        <Col span={12} xs={24} sm={24} lg={12}>
                          <FormItem name="codigoFactura" label="Codigo Factura" margin pattern
                            labelCol={{ span: 10 }} wrapperCol={{ span: 13 }}
                          >
                            <InputItem disabled placeholder="Codigo Factura" />
                          </FormItem>
                          <Row align="middle">
                            <Col span={20}>
                              <FormItem name="descripcion" label="Descripcion" margin pattern
                                labelCol={{ span: 12 }} wrapperCol={{ span: 12 }}
                              >
                                <InputItem placeholder="Descripcion" />
                              </FormItem>
                            </Col>
                            <Col span={4}>
                              <ButtonItem type="primary" blanco onClick={() => this.guardarDescripcion()}>
                                Guardar
                              </ButtonItem>
                            </Col>
                          </Row>
                        </Col>
                        <Col span={12} xs={24} sm={24} lg={12}>
                          <FormItem name="uuid" label="UUID" margin pattern required
                            labelCol={{ span: 10 }} wrapperCol={{ span: 13 }}
                          >
                            <InputItem disabled placeholder="UUID" />
                          </FormItem>
                          <FormItem name="uuidRelacionado" label="UUID Relacionado" margin pattern required
                            labelCol={{ span: 10 }} wrapperCol={{ span: 13 }}
                          >
                            <InputItem disabled placeholder="UUID Relacionado" />
                          </FormItem>
                          <FormItem label="Fecha de N. C." name="fechaFactura" required margin
                            labelCol={{ span: 10 }} wrapperCol={{ span: 10 }}
                          >
                            <DatePickerItem disabled placeholder="Fecha de N. C." allowClear={false} />
                          </FormItem>
                        </Col>
                      </Row>
                    ),
                  },
                  {
                    title: "Moneda",
                    lg: 6,
                    content: (
                      <>
                        <FormItem required margin name="monedaId" label="Moneda"
                          labelCol={{ span: 8 }} wrapperCol={{ span: 16 }}
                          initialValue="60c7e4396465ad440c41c15a"
                        >
                          <SelectItem disabled onChange={(value) => {
                            if (value === "60c7e4396465ad440c41c15a") {
                              this.formRef.current.setFieldsValue({ tipoDeCambio: 1 });
                            }
                          }} placeholder="Moneda">
                            {this.state.objetoMonedas}
                          </SelectItem>
                        </FormItem>
                        <FormItem noStyle shouldUpdate={(prev, curr) => prev.monedaId !== curr.monedaId}>
                          {({ getFieldValue, setFieldsValue }) => {
                            const monedaId = getFieldValue('monedaId');
                            const esMxn = monedaId === '60c7e4396465ad440c41c15a';
                            if (esMxn && getFieldValue('tipoDeCambio') !== 1) {
                              setTimeout(() => setFieldsValue({ tipoDeCambio: 1 }), 0);
                            }
                            return esMxn ? (
                              <FormItem
                                name="tipoDeCambio"
                                hidden
                                initialValue={1}
                              >
                                <InputNumberItem />
                              </FormItem>
                            ) : (
                              <FormItem required number margin label="T. Cambio" name="tipoDeCambio"
                                type="number" initialValue={1}
                                labelCol={{ span: 8 }} wrapperCol={{ span: 16 }}
                              >
                                <InputNumberItem disabled dinero placeholder="T. Cambio" />
                              </FormItem>
                            );
                          }}
                        </FormItem>
                      </>
                    ),
                  },

                ]}
                tabsConfig={{
                  tabs: [
                    {
                      key: "insumos",
                      label: "Insumos",
                      listName: "insumos",
                      columns: this.getInsumosColumns(),
                      renderRow: this.renderInsumoRow.bind(this),
                    },
                    {
                      key: "facturas",
                      label: "Facturas",
                      listName: "facturasRelacionadas",
                      columns: this.getFacturasColumns(),
                      renderRow: this.renderFacturaRow.bind(this),
                    },
                  ],
                }}
                observacionesConfig={this.getObservacionesConfig()}
                isMobile={isMobile}
                actionButtons={
                  <>
                    {this.state.totalPagado > 0 && (
                      <ButtonItem
                        type="primary"
                        icon={<DollarOutlined />}
                        verdeB
                        hotkey="shift+p"
                        style={{ backgroundColor: "green", borderColor: "green" }}
                        onClick={() => this.setState({ modalPagos: true })}
                      >
                        Pagos
                      </ButtonItem>
                    )}
                    <ButtonItem type="primary" hotkey="shift+r"rojoB onClick={this.atras.bind(this)}>
                      Regresar
                    </ButtonItem>
                  </>
                }
              />
            </Form>
          </Spin>
        </div>
        <PagosNotaDeCredito
          visible={this.state.modalPagos}
          id={this.state.id}
          cerrarPagosNotaDeCredito={this.cerrarPagosNotaDeCredito.bind(this)}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
  };
};

export default connect(mapStateToProps)(VerNotaDeCredito);
